import {BaseStaticFieldModalProps} from "../DynamicFormTypes.ts";
import Modal from "../../Modal.tsx";
import SamButton from "../../SamButton.tsx";
import React, {useState} from "react";
import {useFormApi} from "../../../context/ApiContext.tsx";
import {useFormActions, useFormInfo, useFormMethods, useFormStatic} from "../DyanmicFormContext.tsx";

interface Errors {
    zipCode?: boolean;
    mlsIdOrAddress?: boolean;
    noProperty?: boolean;
}

interface FinderForm {
    zipCode?: string;
    mlsId?: string;
    address?: string;
}

export const OriginalComparableFinderModal: React.FC<BaseStaticFieldModalProps> = React.memo(({
                                                                                       isOpen,
                                                                                       onClose,
                                                                                       fieldKey
}) => {
    const { triggerValidation } = useFormMethods()
    const { getActiveFormData } = useFormActions();
    const { applyAutoFillResponse } = useFormInfo();
    const { formPermissions} = useFormStatic()
    const [formData, setFormData] = useState<FinderForm>({
        zipCode: '',
        mlsId: '',
        address: ''
    });

    const [errors, setErrors] = useState<Errors>({
        zipCode: false,
        mlsIdOrAddress: false
    })

    const formApi = useFormApi();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const addComparable = () => {

        setErrors({
            zipCode: false,
            mlsIdOrAddress: false,
            noProperty: false
        });

        if (formData?.zipCode === undefined || formData?.zipCode === '') {
            setErrors(prev => ({
                ...prev,
                zipCode: true
            }));
            return;
        }

        if (formData?.zipCode && (formData?.mlsId === undefined || formData?.mlsId === '') && (formData?.address === undefined || formData?.address === '')) {
            setErrors(prev => ({
                ...prev,
                mlsIdOrAddress: true
            }));
            return;
        }

        setIsSubmitting(true);

        formApi.originalCompAutoFillCall({
            fieldKey: fieldKey,
            activeFormData: getActiveFormData(),
            address: formData?.address,
            zipCode: formData.zipCode,
            mlsId: formData?.mlsId
        }).then(async (response) => {

            if (!formPermissions.canEdit) {
                console.warn("Not allowed to set values here, but got response:", response);
                await triggerValidation();
                onClose();
                return;
            }

            await applyAutoFillResponse(response, {
                triggerValidation: true
            });
            onClose();
        }).catch((e) => {

            console.log("Error in original comp auto fill call", e);
            setErrors(prev => ({
                ...prev,
                noProperty: true
            }));
        }).finally(() => {
            setIsSubmitting(false);
        });
    }

    const handleAddressOrId = (e: React.ChangeEvent<HTMLInputElement>) => {

        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (formData?.mlsId || formData?.address) {
            setErrors(prev => ({
                ...prev,
                mlsIdOrAddress: false
            }))
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={"Add Comparable"}
            maxWidth="md"
        >
            <div className="mb-8">
                <label className="block text-md text-blue-800" htmlFor="addCompZip">
                    Zip Code<span className="text-red-600">*</span>
                </label>
                <input
                    value={formData?.zipCode}
                    onChange={(e) => {

                        if (e.target.value !== undefined) {
                            setErrors(prevState => ({
                                ...prevState,
                                zipCode: false
                            }));
                        }
                        setFormData(prev => ({
                            ...prev,
                            zipCode: e.target.value
                        }))
                    }}
                    type="text"
                    className="mt-1 p-2 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                />
                {errors?.zipCode && (<div className="text-red-600">
                        Zip code is required
                    </div>)
                }
            </div>

            <div>
                <label className="block text-md text-blue-800" htmlFor="addCompZip">
                    MLS ID
                </label>
                <input
                    name="mlsId"
                    value={formData.mlsId}
                    onChange={handleAddressOrId}
                    type="text"
                    className="mt-1 p-2 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                />
                <div className="text-red-600 m-1">
                    OR {errors.mlsIdOrAddress && (<span className="ml-3">MLS Id or Address Needed</span>)}
                </div>
                <label className="block text-md text-blue-800" htmlFor="addCompZip">
                    Address
                </label>
                <input
                    name="address"
                    value={formData.address}
                    onChange={handleAddressOrId}
                    type="text"
                    className="mt-1 p-2 block w-full rounded-md border border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                />
            </div>

            <div className="mt-3 flex justify-between items-center">
                {errors.noProperty ? (
                    <span className="text-red-600">Could not find the property</span>
                ) : (
                    <div></div>
                )}

                {isSubmitting ? (
                    <div className="ml-4 flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-md">
                        <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 01-8 8z"></path>
                        </svg>
                        Submitting...
                    </div>
                ) : (
                    <SamButton className="ml-4" onClick={addComparable}>
                        Add
                    </SamButton>
                )}
            </div>
        </Modal>
    );
});